<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-cloud-upload"></i> Select Files
  </h5>
  <button (click)="close.emit()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div class="main-container">
    <div class="left">
      <div class="title">Available files ({{available.length}})</div>
      <mat-form-field [floatLabel]="'never'" class="search mat-block">
        <input [(ngModel)]="queryAvailable" matInput placeholder="Search here..." type="text">
        <i class="far fa-search"></i>
      </mat-form-field>
      <div class="items">
        <div *ngFor="let item of available | search:'attachment.name':queryAvailable" class="item">
          <mat-checkbox [(ngModel)]="item.selected">
            {{item.attachment.name}}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="controls">
      <div class="buttons">
        <div class="buttons-block">
          <button class="btn btn-cst-primary" (click)="onMoveAvailable()"><i class="fal fa-angle-right"></i></button>
          <button class="btn btn-cst-primary" (click)="onMoveAllAvailable()"><i class="fal fa-angle-double-right"></i></button>
        </div>
        <div class="buttons-block">
          <button class="btn btn-cst-primary" (click)="onMoveSelected()"><i class="fal fa-angle-left"></i></button>
          <button class="btn btn-cst-primary" (click)="onMoveAllSelected()"><i class="fal fa-angle-double-left"></i></button>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="title">Selected files ({{selected.length}})</div>
      <mat-form-field [floatLabel]="'never'" class="search mat-block">
        <input [(ngModel)]="querySelected" matInput placeholder="Search here..." type="text">
        <i class="far fa-search"></i>
      </mat-form-field>
      <div class="items">
        <div *ngFor="let item of selected | search:'attachment.name':querySelected" class="item">
          <mat-checkbox [(ngModel)]="item.selected">
            {{item.attachment.name}}
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="onDone()" [disabled]="!selected.length" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-save"></i> Select
  </button>
</div>
